import { render, staticRenderFns } from "./ManagerLayout.vue?vue&type=template&id=1c50954e&scoped=true"
import script from "./ManagerLayout.vue?vue&type=script&lang=js"
export * from "./ManagerLayout.vue?vue&type=script&lang=js"
import style0 from "./ManagerLayout.vue?vue&type=style&index=0&id=1c50954e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50954e",
  null
  
)

export default component.exports